import { GridColDef } from "@mui/x-data-grid";
import { calcMargem, formatMoney, getNewId, isEmpty } from "../../../services/utils";
import ViewCad from "../../../view";
import { ItemViewProps } from "../item.controll";
import { Item } from "../item.model";
import ViewForm from "../../../components/viewCadastro/viewForm";
import { Convenio, TabelaPrecoItem, ValorMpCondicional } from "../../../data.types";
import { Cancel, CheckCircle, Delete } from "@mui/icons-material";
import Modal from "../../../components/modal";
import { useCallback, useState } from "react";
import { ContentForm } from "../../../components/viewCadastro/formCad";
import { Box, Divider, Grid, IconButton } from "@mui/material";
import { handleShowTabelaPrecoSelect, TabelaPrecoSelect } from "../../settings/tabelaPreco/tabpreco.view";
import { ConvenioSelect, handleShowConvenioSelect } from "../../settings/convenio/convenio.view"
import { handleSetShowSelectMeioPagModal, MeioPagSelectList } from "../../meioPag/view/meiopg.select";


const columnsTabPreco: GridColDef[] = [
    { field: 'descricao', headerName: 'Descricão', flex: 3, },
    { field: 'valor', headerName: 'Preço', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
    { field: 'ativo', headerName: 'Ativo?', flex: 2, renderCell: (prm) => prm.value ? "Sim" : "Não" },
]

const meioPagsCondicional = (rows:Array<{_id:any,descricao:string}>) => {
    console.log("meioPagsCondicional rows",rows);
    let condicao = ""
    rows.map((row,idx)=>{
        if(idx === 0)
            condicao = condicao + row.descricao
        else
            condicao = condicao + " | " + row.descricao
    })
    return condicao
}

const columnsValorConvenio: GridColDef[] = [
    { field: 'valor', headerName: 'Valor do convênio', flex: 4, renderCell: (prm) => formatMoney(prm.value) },
    { field: 'mp_condicional', headerName: 'Meio pag. condicional', flex: 8, renderCell: (prm) => prm.value.length === 0 ? "Todos Meios Pag." : meioPagsCondicional(prm.value) },
]

interface ItemCadastroProps extends ItemViewProps {
    handleCloseView: () => any
}

export function ItemCadastro(props: ItemCadastroProps) {
    const { itemActions, itemState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = itemState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = itemActions


    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Item) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Item) => {
        const errors: any = {}
        if (!values.descricao)
            errors.nome = "Informe a descrição do item"
        return errors
    }

    const handleUpdate = (value: Item) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        try {
            console.log("handleMutator", value, field)
            let custo = state.formState.values.custo;
            let margem_var = state.formState.values.margem_var;
            let margem_ata = state.formState.values.margem_ata;
            let preco_var: any
            let preco_ata: any
            if (field === "custo") {
                preco_var = calcMargem("$", margem_var, value);
                preco_ata = calcMargem("$", margem_ata, value);
                changeValue(state, "preco_var", () => preco_var);
                changeValue(state, "preco_ata", () => preco_ata);
            }
            if (field === "margem_var") {
                preco_var = calcMargem("%", value, custo);
                changeValue(state, "preco_var", () => preco_var);
            }
            if (field === "margem_ata") {
                preco_ata = calcMargem("%", value, custo);
                changeValue(state, "preco_ata", () => preco_ata);
            }
            if (field === "preco_var") {
                margem_var = calcMargem("$", value, custo);
                changeValue(state, "margem_var", () => margem_var);
            }
            if (field === "preco_ata") {
                margem_ata = calcMargem("$", value, custo);
                changeValue(state, "margem_ata", () => margem_ata);
            }
            if (field === "tabela_preco") {
                changeValue(state, "tabela_preco", () => value);
            }
            if (field === "convenios") {
                changeValue(state, "convenio_preco.convenios", () => value);
            }
            if (field === "valor_mp_cond") {
                changeValue(state, "convenio_preco.valor_mp_cond", () => value);
            }            

        } catch (error) {
            console.log("Error handleMutator", error);
        }

    }



    var viewCad = new ViewCad({
        formTitle: "Cadastro de itens",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo item",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        handleMutator: handleMutator,
        contentForm: [
            { fieldName: "codigo", label: "Código", type: "text", key: "codigo", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true },
            { fieldName: "descricao", label: "Descrição", type: "text", key: "nome", colunsXS: 6, colunsSM: 6, colunsMD: 6, require: true },
            { fieldName: "custo", label: "Preço Custo", type: "currency", key: "custo", colunsXS: 3, colunsSM: 3, colunsMD: 3, handleChangeMutator: (func, value, form) => { func(value, "custo", func) }, },
            { fieldName: "comissao", label: "Comissão", type: "currency", key: "comissao", colunsXS: 6, colunsSM: 6, colunsMD: 3, tip: "Valor de comisão para cada unidade vendida" },
            { fieldName: "qt_max_estoque", label: "Qtde. Max. Estocar", type: "number", key: "qt_max_estoque", colunsXS: 6, colunsSM: 6, colunsMD: 3, tip: "Quantidade maxima comprar para estocar." },
            { fieldName: "info_dt_validade", label: "Tem Validade?", type: "checkbox", key: "ativo", tip: "Informar validade na venda?", colunsXS: 6, colunsSM: 6, colunsMD: 3, },
            { fieldName: "ativo", label: "Ativo?", type: "checkbox", key: "ativo", colunsXS: 6, colunsSM: 6, colunsMD: 3, },
            // { fieldName: "tabela_preco", label: "Tabela de Preço", type: "list", key: "tabela_preco_hidden", colunsXS: 12, colunsSM: 12, colunsMD: 12,hidden:true}
        ],
        ContentBox: (props) => {
            const [showModalFormTabela, setShowModalFormTabela] = useState<{ show: boolean, tabela: TabelaPrecoItem }>({ show: false, tabela: valueInitialTabelaPrecoItem });
            const [showModalFormConvenio, setShowModalFormConvenio] = useState<{ show: boolean, convenio: ValorMpCondicional }>({ show: false, convenio: valueInitialValorMpCondicional });

            const ViewFormTabelaPreco = useCallback((propsView: any) => {
                console.log("ViewFormTabelaPreco", props);
                let item = props ? props.values : {} as Item
                let tabela = [...item.tabela_preco] as TabelaPrecoItem[];
                return (
                    <FormAddTabelaPreco
                        confirmar={(value) => {
                            console.log("confirmar", value);
                            let find = tabela.findIndex(tab => tab._id === value._id)
                            if (find === -1)
                                tabela.push(value)
                            else
                                tabela[find] = value;
                            props?.form.mutators.handleMutator(tabela, "tabela_preco")
                        }}
                        handleClose={() => setShowModalFormTabela({ show: false, tabela: valueInitialTabelaPrecoItem })}
                        row={showModalFormTabela.tabela}
                        showModal={showModalFormTabela.show}

                    />
                )

            }, [showModalFormTabela])

            const ViewFormValorConvenio = useCallback(() => {
                let item = props ? props.values : {} as Item
                let valor_mp_cond = [] as ValorMpCondicional[];
                if(item.convenio_preco?.valor_mp_cond !== undefined)
                    valor_mp_cond = [...item.convenio_preco?.valor_mp_cond]
                return (
                    <FormAddValorConvenio
                        confirmar={(value) => {
                            console.log("confirmar", value);
                            let find = valor_mp_cond.findIndex(val => val._id === value._id)
                            if (find === -1){
                                value._id = getNewId();
                                valor_mp_cond.push(value)
                            } else
                                valor_mp_cond[find] = value;
                            props?.form.mutators.handleMutator(valor_mp_cond, "valor_mp_cond")
                        }}
                        handleClose={() => setShowModalFormConvenio({ show: false, convenio: valueInitialValorMpCondicional })}
                        row={showModalFormConvenio.convenio}
                        showModal={showModalFormConvenio.show}

                    />
                )

            }, [showModalFormConvenio])            

            const handleRemoveTabela = (value: TabelaPrecoItem) => {
                console.log("Excluir", value);
                let item = props ? props.values : {} as Item
                let tabelas = [...item.tabela_preco] as TabelaPrecoItem[];
                let find = tabelas.findIndex(tab => tab._id === value._id)
                tabelas.splice(find, 1);
                props?.form.mutators.handleMutator(tabelas, "tabela_preco")
            }

            const handleRemoveValorConvenio = (value: ValorMpCondicional) => {
                console.log("Excluir", value);
                let item = props ? props.values : {} as Item
                let valorMpcCondicional = [...item.convenio_preco?.valor_mp_cond!] as ValorMpCondicional[];
                let find = valorMpcCondicional.findIndex(val => val._id === value._id)
                valorMpcCondicional.splice(find, 1);
                props?.form.mutators.handleMutator(valorMpcCondicional, "valor_mp_cond")
            }            
            return (
                <Box sx={{flex:1}}>
                <Grid container spacing={2}>
                    <ContentForm
                        fieldName="tabela_preco"
                        label={`Tabela de Preço ${props && props.values.tabela_preco.length > 0 ? `(Duplo click na tabela para editar)` : ``}`}
                        type="list"
                        colunsXS={12}
                        colunsSM={12}
                        colunsMD={12}
                        columns={[...columnsTabPreco, { field: "_id", headerName: "#", renderCell: (prm) => <IconButton size="small" title="Remover tabela" onClick={() => handleRemoveTabela(prm.row)}><Delete /></IconButton> }]}
                        fieldList={{ fieldPrimary: "descricao", fieldSecondary: "valor", fieldSecondaryEnd: "ativo" }}
                        fieldId="_id"
                        handleOnClickUpdade={(v) => setShowModalFormTabela({ show: true, tabela: v })}
                        handleOnClickShow={() => setShowModalFormTabela({ show: true, tabela: valueInitialTabelaPrecoItem })}
                        tip="Adicionar tabela de preço"
                        ViewSelecionarDialog={ViewFormTabelaPreco}

                    />
                    <ContentForm
                        fieldName="convenio_preco.convenios"
                        label={"Convênios"}
                        type="chips"
                        colunsXS={9}
                        colunsSM={9}
                        colunsMD={9}
                        tip="Adicionar convênio"
                        handleOnClickShow={() => handleShowConvenioSelect(true)}
                        radioDefaultValue={"descricao"}
                        ViewSelecionarDialog={() => {
                            var convenios = [] as any[];
                            if(props?.values.convenio_preco?.convenios !== undefined)
                                convenios = [...props?.values.convenio_preco?.convenios];

                            const addConvenio = (row: any) => {
                                let find = convenios.find(val=>val._id === row._id)
                                if(!find){
                                    convenios.push({ _id: row._id, descricao: row.descricao, })
                                    props?.form.mutators.handleMutator(convenios, "convenios")
                                }
                            }

                            return (
                                <ConvenioSelect handleConvenioSelect={(rowSelected) => {
                                    console.log("handleConvenioSelect", rowSelected)
                                    addConvenio(rowSelected);
                                    handleShowConvenioSelect(false);
                                }}
                                />
                            )

                        }}
                        handleOnClickRemove={(value)=>{
                            console.log("Remove",value);
                            let convenios = [...props?.values.convenio_preco?.convenios!];
                            let find = convenios.findIndex(val=>val._id === row._id)
                            convenios.splice(find,1);
                            props?.form.mutators.handleMutator(convenios, "convenios")
                        }}
                    />
                    {props?.values.convenio_preco && props.values.convenio_preco.convenios.length > 0 && (
                        <ContentForm
                            fieldName="convenio_preco.valor_mp_cond"
                            label={`Valores relacionado ao convênio (Duplo click no valor para editar.)`}
                            type="list"
                            colunsXS={12}
                            colunsSM={12}
                            colunsMD={12}
                            columns={[...columnsValorConvenio, { field: "_id", headerName: "#", renderCell: (prm) => <IconButton size="small" title="Remover valor convênio" onClick={() => handleRemoveValorConvenio(prm.row)}><Delete /></IconButton> }]}
                            fieldId="_id"
                            handleOnClickUpdade={(v) => setShowModalFormConvenio({ show: true, convenio: v })}
                            handleOnClickShow={() => setShowModalFormConvenio({ show: true, convenio: valueInitialValorMpCondicional })}
                            tip="Adicionar valor condicional do convênio"
                            ViewSelecionarDialog={ViewFormValorConvenio}

                        />
                    )}
                </Grid>
                </Box>


            )
        }

    })

    return viewCad
}

const valueInitialTabelaPrecoItem: TabelaPrecoItem = {
    _id: "", ativo: false, descricao: "", valor: 0, _rev: undefined, created_at: "", modified_at: "", type: "tabelapreco"
}

interface FormAddTabelaPrecoProps {
    showModal: boolean,
    handleClose: () => any
    row: TabelaPrecoItem
    confirmar: (value: TabelaPrecoItem) => any
}
const FormAddTabelaPreco = (props: FormAddTabelaPrecoProps) => {
    const { handleClose, row, showModal, confirmar } = props

    const SelecionarTabelaPreco = (propsTabela: any) => {
        return (
            <TabelaPrecoSelect handleTabelaPrecoSelect={(row) => {
                let value = {
                    _id: row._id,
                    descricao: row.descricao,
                    ativo: row.ativo,
                    type:row.type,
                }
                propsTabela.handleMutator(value)
                handleShowTabelaPrecoSelect(false);
            }} />
        )
    }
    const View = ViewForm({
        row: row,
        contentForm: [
            {
                fieldName: "descricao",
                type: "select-dialog",
                label: "Tabela do preço",
                colunsXS: 5,
                colunsSM: 5,
                colunsMD: 5,
                ViewSelecionarDialog: SelecionarTabelaPreco,
                handleOnClickShow: () => handleShowTabelaPrecoSelect(true)

            },
            { fieldName: "valor", type: "currency", label: "Preço", colunsXS: 4, colunsSM: 4, colunsMD: 4 },
            { fieldName: "ativo", type: "checkbox", label: "Ativo", colunsXS: 3, colunsSM: 3, colunsMD: 3 },

        ],
        handleOnSubmit: function (values: TabelaPrecoItem): void {
            confirmar(values);
            handleClose();
        },

        handleCancel: function (): void {
            handleClose()
        },
        handleMutator: function ([value, field]: [any, any], state: any, { changeValue }: { changeValue: any; }): void {
            console.log("value selecionado", value, field)
            changeValue(state, "_id", () => value._id)
            changeValue(state, "descricao", () => value.descricao)
        },
        formValidation: function (value: TabelaPrecoItem): void {
            let error: any = {}
            if (isEmpty(value._id))
                error.tabela = "Informe a tabela do preço."
            if (isEmpty(value.valor))
                error.valor = "Informe o preço"
            return error;
        },
        buttonActions: [
            {
                label: "Cancelar",
                color: "primary",
                type: "button",
                icon: <Cancel />,
                handleOnClick: () => handleClose()
            },

            {
                label: "Confirmar",
                color: "success",
                type: "submit",
                icon: <CheckCircle />
            }
        ]
    })

    return (
        <Modal
            open={showModal}
            handleClose={handleClose}
            component={View}
            width={"sm"}
            heigth={"auto"}
            handleOnKeyDown={() => { }}
        />
    )
}


const valueInitialValorMpCondicional: ValorMpCondicional = {
    _id: "", mp_condicional: [], valor: 0
}

interface FormAddValorConvenioProps {
    showModal: boolean,
    handleClose: () => any
    row: ValorMpCondicional
    confirmar: (value: ValorMpCondicional) => any
}
const FormAddValorConvenio = (props: FormAddValorConvenioProps) => {
    const { handleClose, row, showModal, confirmar } = props

    const SelecionarMeioPag = (propsMeioPag: any) => {
        console.log("propsMeioPag",propsMeioPag)
        return (
            <MeioPagSelectList handleMeioPagSelect={(meioPag) => {
                let value = {
                    _id: meioPag._id,
                    descricao: meioPag.descricao
                };
                propsMeioPag.handleMutator(value,"add");
                handleSetShowSelectMeioPagModal(false)
            }} />
        )
    }
    const View = ViewForm({
        row: row,

        contentForm: [
            { fieldName: "valor", type: "currency", label: "Preço do convênio", colunsXS: 4, colunsSM: 4, colunsMD: 4 },
            {
                fieldName: "mp_condicional",
                type: "chips",
                label: "Meios de pagamento condicional",
                colunsXS: 12,
                colunsSM: 12,
                colunsMD: 12,
                radioDefaultValue:"descricao",
                ViewSelecionarDialog: SelecionarMeioPag,
                handleOnClickShow: () => handleSetShowSelectMeioPagModal(true),
                handleOnClickRemove:((row,mutator)=>{
                    mutator&&mutator(row,"rem");
                })
            },
        ],
        handleOnSubmit: function (values: any): void {
            if(values.valor > 0){
                confirmar(values);
                handleClose();
            }
        },

        handleCancel: function (): void {
            handleClose()
        },
        handleMutator: function ([value, field]: [any, any], state: any, { changeValue }: { changeValue: any; }): void {
            console.log("value selecionado", value, field,state)
            let rows = [...state.formState.values.mp_condicional]
            let find  = rows.findIndex(row=>row._id === value._id)
            if(field === "add"){
                if(find === -1){
                    rows.push(value);
                    changeValue(state, "mp_condicional", () => rows)
                }
            }
            if(field === "rem"){
                rows.splice(find,1);
                changeValue(state, "mp_condicional", () => rows)
            }
                
        },
        formValidation: function (value: TabelaPrecoItem): void {
            let error: any = {}
            if (isEmpty(value.valor))
                error.valor = "Informe o valor do item pelo convênio"
            return error;
        },
        buttonActions: [
            {
                label: "Cancelar",
                color: "primary",
                type: "button",
                icon: <Cancel />,
                handleOnClick: () => handleClose()
            },

            {
                label: "Confirmar",
                color: "success",
                type: "submit",
                icon: <CheckCircle />
            }
        ]
    })

    return (
        <Modal
            open={showModal}
            handleClose={handleClose}
            component={View}
            width={"sm"}
            heigth={"auto"}
            handleOnKeyDown={() => { }}
        />
    )
}


